import { createSlice } from "@reduxjs/toolkit";

// job.status: 'processing' | 'extracting' | 'done' | 'error'
// file.status: 'pending' | 'uploading' | 'parsing' | 'done' | 'error'

const initialState = {
  jobs: {},
};

const ocrSlice = createSlice({
  name: "ocr",
  initialState,
  reducers: {
    initJob(state, action) {
      const { jobKey, patientId, appointmentId, patientName, files } = action.payload;
      state.jobs[jobKey] = {
        patientId,
        appointmentId,
        patientName: patientName || "",
        status: "processing",
        files: files.map((f) => ({
          name: f.name,
          status: "pending",
          fileKey: null,
          ocrText: null,
          error: null,
        })),
        extractionResult: null,
        error: null,
        startedAt: Date.now(),
      };
    },
    setFileStatus(state, action) {
      const { jobKey, fileIdx, status } = action.payload;
      const job = state.jobs[jobKey];
      if (job?.files?.[fileIdx]) job.files[fileIdx].status = status;
    },
    setFileKey(state, action) {
      const { jobKey, fileIdx, fileKey } = action.payload;
      const job = state.jobs[jobKey];
      if (job?.files?.[fileIdx]) job.files[fileIdx].fileKey = fileKey;
    },
    setFileDone(state, action) {
      const { jobKey, fileIdx, ocrText } = action.payload;
      const job = state.jobs[jobKey];
      if (job?.files?.[fileIdx]) {
        job.files[fileIdx].status = "done";
        job.files[fileIdx].ocrText = ocrText;
      }
    },
    setFileError(state, action) {
      const { jobKey, fileIdx, error } = action.payload;
      const job = state.jobs[jobKey];
      if (job?.files?.[fileIdx]) {
        job.files[fileIdx].status = "error";
        job.files[fileIdx].error = error;
      }
    },
    setJobStatus(state, action) {
      const { jobKey, status } = action.payload;
      if (state.jobs[jobKey]) state.jobs[jobKey].status = status;
    },
    setJobDone(state, action) {
      const { jobKey, extractionResult } = action.payload;
      if (state.jobs[jobKey]) {
        state.jobs[jobKey].status = "done";
        state.jobs[jobKey].extractionResult = extractionResult;
      }
    },
    setJobError(state, action) {
      const { jobKey, error } = action.payload;
      if (state.jobs[jobKey]) {
        state.jobs[jobKey].status = "error";
        state.jobs[jobKey].error = error;
      }
    },
    clearJob(state, action) {
      delete state.jobs[action.payload.jobKey];
    },
  },
});

export const {
  initJob,
  setFileStatus,
  setFileKey,
  setFileDone,
  setFileError,
  setJobStatus,
  setJobDone,
  setJobError,
  clearJob,
} = ocrSlice.actions;

export default ocrSlice.reducer;
